import React from "react";
import { formatNumberToDisplayWithCommas } from "../../../common/shared";

const CORE_DISCIPLINE_IDS = ['1', '2'];

const REAM_COLUMNS = [
    {
        Header: 'Ream From',
        accessor: 'ream_from',
        Cell: (cell) => formatNumberToDisplayWithCommas(cell.value),
    },
    {
        Header: 'Ream To',
        accessor: 'ream_to',
        Cell: (cell) => formatNumberToDisplayWithCommas(cell.value),
    },
    {
        Header: 'Ream Total',
        accessor: 'ream_total',
        Cell: (cell) => formatNumberToDisplayWithCommas(cell.value),
    },
];

const CORE_DISCIPLINE_COLUMNS = [
    {
        Header: 'Runs',
        accessor: 'runs',
    },
    {
        Header: 'Core Retrieved',
        accessor: 'core_retrieved',
    }
];

const DailiesTable = (selectedDisciplineId) => {
    const isCoreDisciplineSelected = CORE_DISCIPLINE_IDS.includes(selectedDisciplineId);

    return [
        {
            Header: 'Date',
            accessor: 'date',
            width: 70,
            Cell: (cell) => {
                const row = cell.row.original;
                let result = '';
                result = (row.status > 0)
                    ?
                        (
                            <a
                                href={`/data_entry/daily/daily/edit/${row.daily_id}`}
                                rel="noopener noreferrer"
                                target="_blank"
                            >
                                <b>{cell.value}</b>
                            </a>
                        )
                    :
                        cell.value;
                return result;
            }
        },
        {
            Header: 'Shift',
            accessor: 'shift',
            width: 40,
        },
        {
            Header: 'Rig',
            accessor: 'rig',
        },
        {
            Header: 'Job',
            accessor: 'job',
            width: 85,
        },
        {
            Header: 'Hole',
            accessor: 'hole',
        },
        {
            Header: 'Depth From',
            accessor: 'depth_from',
            Cell: (cell) => formatNumberToDisplayWithCommas(cell.value),
        },
        {
            Header: 'Depth To',
            accessor: 'depth_to',
            Cell: (cell) => formatNumberToDisplayWithCommas(cell.value),
        },
        {
            Header: 'Depth Total',
            accessor: 'depth_total',
            Cell: (cell) => formatNumberToDisplayWithCommas(cell.value),
        },
        ...(isCoreDisciplineSelected ? [] : REAM_COLUMNS),
        {
            Header: 'Variance',
            accessor: 'variance',
        },
        ...(isCoreDisciplineSelected ? CORE_DISCIPLINE_COLUMNS : []),
        {
            Header: 'Hours',
            accessor: 'hours',
            width: 60,
        },
        {
            Header: 'Unbilled Hours',
            accessor: 'unbilled_hours',
        },
        {
            Header: 'Revenue',
            accessor: 'revenue',
            Cell: (cell) => formatNumberToDisplayWithCommas(cell.value),
        },
        {
            Header: 'Invoice',
            accessor: 'invoice',
        },
        {
            Header: 'Status',
            accessor: 'invoice_status',
            width: 60,
            Cell: (cell) => {
                const row = cell.row.original;

                if (typeof row.invoice_status !== 'undefined') {
                    switch (row.invoice_status) {
                        case 1:
                            return 'Draft';
                        case 2:
                            return 'Sent';
                        case 3:
                            return 'Final';
                        default:
                            return null;
                    }
                } else {
                    return null;
                }
            }
        },
        {
            Header: 'Created By',
            accessor: 'created_by',
        },
        {
            Header: 'Modified By',
            accessor: 'modified_by',
        },
    ];
}

export default DailiesTable;

